exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.VueCarousel-inner {\n  align-items: center;\n  min-height: 300px;\n}\n.VueCarousel-slide { text-align: center !important;\n}\n.VueCarousel-dot {\n  padding: 2px 4px !important;\n}\n.VueCarousel-dot-inner {\n  background: #fff !important;\n  border: 1px solid #9D77BA !important;\n}\n.VueCarousel-dot--active .VueCarousel-dot-inner {\n  background: #9D77BA !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ec835532","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/ProductListItem.vue
// module id = 603
// module chunks = 1